export const getSegmentWizardRoute = (currentModule: string): string => `${currentModule}-wizard`;
